<ion-app darkMode largeFont>
  <ion-split-pane contentId="main-content">
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
